import Vue from 'vue';
import _ from "lodash";

import {
  DASHBOARD_LIST_GET,
  DASHBOARD_LIST_META_SET,
  DASHBOARD_REALTY_LIST_GET,
  DASHBOARD_ANALYST_LIST_GET,
  DASHBOARD_PROPERTY_SET,
  DASHBOARD_PROPERTY_REPORT_UPDATE,
} from '../mutations-types'

const state = {
  dashboardLists: [null, null, null],

  dashboardListMetaDefault: {
    perPage: 10,
    currentTypeId: 0,
    list: [
      {
        title: 'New',
        request: 'new',
        meta: null,
        pageId: 1,
        params: [
          {
            attr: 'realty',
            val: null
          }
        ]
      },
      {
        title: 'In Progress',
        request: 'in_progres',
        meta: null,
        pageId: 1,
        params: [
          {
            attr: 'user_id',
            val: undefined,
          }
        ]
      },
      {
        title: 'Archived',
        request: 'archived',
        meta: null,
        pageId: 1,
        params: [
          {
            attr: 'user_id',
            val: undefined,
          }
        ]
      }
    ]
  },
  dashboardListMeta: {
    perPage: 10,
    currentTypeId: 0,
    list: [
      {
        title: 'New',
        request: 'new',
        meta: null,
        pageId: 1,
        params: [
          {
            attr: 'realty',
            val: null
          }
        ]
      },
      {
        title: 'In Progress',
        request: 'in_progres',
        meta: null,
        pageId: 1,
        params: [
          {
            attr: 'user_id',
            val: undefined,
          }
        ]
      },
      {
        title: 'Archived',
        request: 'archived',
        meta: null,
        pageId: 1,
        params: [
          {
            attr: 'user_id',
            val: undefined,
          }
        ]
      }
    ],
    meta: null
  },

  dashboardRealtyList: null,
  dashboardAnalystList: null,
  dashboardProperty: null,
};

const getters = {
  dashboardLists: state => state.dashboardLists,
  dashboardListMeta: state => state.dashboardListMeta,
  dashboardListMetaDefault: state => state.dashboardListMetaDefault,
  dashboardRealtyList: state => state.dashboardRealtyList,
  dashboardAnalystList: state => state.dashboardAnalystList,
  dashboardProperty: state => state.dashboardProperty,
};

const mutations = {
  [DASHBOARD_REALTY_LIST_GET](state, data) {
    let collection = [];

    if (data.length > 0) {
      collection.push({
        title: 'All',
        val: null
      });

      data.forEach(item => {
        collection.push({
          title: item,
          val: item
        });
      })
    } else {
      collection = null;
    }

    Vue.set(state, 'dashboardRealtyList', collection);
  },

  [DASHBOARD_ANALYST_LIST_GET](state, data) {
    data.unshift({
      firstName: 'All',
      lastName: '',
      external_user_id: null,
    })

    Vue.set(state, 'dashboardAnalystList', data);
  },

  [DASHBOARD_LIST_GET](state, data) {
    Vue.set(state.dashboardLists, data.typeId, data.list.data.length > 0 ? data.list.data : []);
    Vue.set(state.dashboardListMeta.list[data.typeId], 'meta', data.list.meta ? data.list.meta : null);
  },

  [DASHBOARD_LIST_META_SET](state, data) {
    Vue.set(state, 'dashboardListMeta', data);
  },

  [DASHBOARD_PROPERTY_SET](state, data) {
    Vue.set(state, 'dashboardProperty', data);
  },

  [DASHBOARD_PROPERTY_REPORT_UPDATE](state, data) {
    let dashboardProperty = _.cloneDeep(state.dashboardProperty),
        reportType = data.reportType;
    delete data.reportType;
    dashboardProperty[reportType].data[0] = data;
    Vue.set(state, 'dashboardProperty', dashboardProperty);
  },
};

const actions = {
  /**
   * @note
   * require auth
   * @URLParams
   * none
   * @BodyParams
   * none
   * **/
  DASHBOARD_REALTY_LIST_REQUEST_GET ({ state, commit }) {
    return new Promise((resolve, reject) => {
      Vue.axios.get('/dashboard/firms')
        .then(response => {
          commit(DASHBOARD_REALTY_LIST_GET, response.data);
          resolve();
        }).catch(error => {
        reject();
      });
    });
  },

  /**
   * @note
   * require auth
   * @URLParams
   * none
   * @BodyParams
   * none
   * **/
  DASHBOARD_ANALYST_LIST_REQUEST_GET ({ state, commit }) {
    return new Promise((resolve, reject) => {
      Vue.axios.get('/dashboard/users')
        .then(response => {
          commit(DASHBOARD_ANALYST_LIST_GET, response.data);
          resolve();
        }).catch(error => {
        reject();
      });
    });
  },

  /**
   * @note
   * require auth
   * @URLParams
   * sort:     integer
   * page:     integer, required
   * per_page: integer, required
   * @BodyParams
   * none
   * **/
  DASHBOARD_LIST_REQUEST_GET ({ state, commit }, data) {
    let requestParams = {
      status: state.dashboardListMeta.list[data.typeId].request,
      page: state.dashboardListMeta.list[data.typeId].pageId,
      per_page: state.dashboardListMeta.perPage
    };

    state.dashboardListMeta.list[data.typeId].params.forEach(param => {
      if (param.val !== null) {
        requestParams[param.attr] = param.val
      }
    });

    return new Promise((resolve, reject) => {
      Vue.axios.get('/dashboard/listings', {
        params: requestParams
      })
        .then(response => {
          commit(DASHBOARD_LIST_GET, {
            typeId: data.typeId,
            list: response.data
          });
          resolve();
        }).catch(error => {
          reject();
        });
    });
  },

  /**
   * NOTE: none
   * @URLParams
   * none
   * @BodyParams
   * none
   * **/
  DASHBOARD_PROPERTY_REQUEST_GET ({ state, commit }, listingId) {
    return new Promise((resolve, reject) => {
      if (state.propertyInfo && state.propertyInfo.id === listingId) {
        resolve();
      } else {
        Vue.axios.get('/listings/' + listingId)
          .then((response) => {
            let data = null;
            if (response.data.data.length > 0) {
              data = response.data.data[0];
            }
            commit(DASHBOARD_PROPERTY_SET, data);
            resolve();
          }).catch(error => {
          reject();
        });
      }
    });
  },

  /**
   * NOTE: none
   * @URLParams
   * none
   * @BodyParams
   * status_id: integer, required
   * **/
  DASHBOARD_PROPERTY_STATUS_REQUEST_SET ({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      Vue.axios.put('/listings/' + data.listingId + '/update_status', data.payload)
        .then((response) => {
          resolve();
        }).catch(error => {
        reject();
      });
    });
  },

  /**
   * NOTE: none
   * @URLParams
   * none
   * @BodyParams
   * status_id: integer, required
   * **/
  DASHBOARD_PROPERTY_REPORTS_CONTACT_REQUEST_SET ({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('reports/' + data.report_id + '/info', data.payload)
        .then(results => {
          resolve();
        }).catch(error => {
        reject();
      });
    });
  },

  /**
   * NOTE: none
   * @URLParams
   * reportId: integer, required
   * @BodyParams
   * none
   * **/
  DASHBOARD_PROPERTY_REPORTS_REQUEST_RESET ({ state, commit, rootState }, data) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('reports/' + data.reportId + '/reset')
        .then(results => {
          commit(DASHBOARD_PROPERTY_REPORT_UPDATE,
            {...results.data.data, reportType: data.reportType}
            );
          resolve();
        }).catch(error => {
        reject();
      });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};